import { ResponsibleGamingLayout } from '../responsible-gaming/layouts/responsible-gaming/responsible-gaming';
import responsibleGamingRoutes from '../responsible-gaming/responsible-gaming.routes';
import { RewardsLayout } from '../rewards/layouts/rewards';
import rewardsRoutes from '../rewards/rewards.routes';
import { ContextNavigate } from '../shared/components/context-navigate/context-navigate';
import { TransactionsLayout } from '../transactions/layouts/transactions/transactions';
import transactionsRoutes from '../transactions/transactions.routes';

import { UserProfile } from './components/profile/profile';
import { OverviewPage } from './containers/overview-page/overview-page';
import { Sessions } from './containers/sessions/sessions';
import { SettingsPage } from './containers/settings-page/settings-page';
import { UserVerification } from './containers/verification-page/verification';

export default [
    {
        path: 'overview',
        element: <OverviewPage />,
    },
    {
        path: 'rewards',
        element: <RewardsLayout />,
        children: rewardsRoutes,
    },
    {
        path: 'sessions',
        element: <Sessions />,
    },
    {
        path: 'profile',
        element: <UserProfile />,
    },
    {
        path: 'settings',
        element: <SettingsPage />,
    },
    {
        path: 'transactions',
        element: <TransactionsLayout />,
        children: transactionsRoutes,
    },
    {
        path: 'verification',
        element: <UserVerification />,
    },
    {
        path: 'responsible-gaming',
        element: <ResponsibleGamingLayout />,
        children: responsibleGamingRoutes,
    },
    {
        index: true,
        element: <ContextNavigate to="/account/overview" />,
    },
];
